"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _Image = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Image"));
var _ViewportProvider = require("../ViewportProvider");
var _ThemeProvider = require("../ThemeProvider");
var _dictionary = _interopRequireDefault(require("./dictionary"));
var _utils = require("../utils");
var _Badge = _interopRequireDefault(require("../Badge"));
var _PriceLockup = _interopRequireDefault(require("../PriceLockup"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _Button = require("../Button");
var _StackView = _interopRequireDefault(require("../StackView"));
var _Box = _interopRequireDefault(require("../Box"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.htmlAttrs, _utils.viewProps, _utils.a11yProps]);
const selectProductCardTokens = _ref => {
  let {
    borderStyle,
    borderColor,
    borderWidth,
    borderRadius,
    paddingHorizontal,
    paddingVertical
  } = _ref;
  return {
    borderStyle,
    borderColor,
    borderWidth,
    borderRadius,
    paddingHorizontal,
    paddingVertical
  };
};
const ProductCard = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    copy = 'en',
    dictionary = _dictionary.default,
    image = {
      src: '',
      alt: ''
    },
    cardId,
    isSelected,
    onSelect,
    tokens,
    ...rest
  } = _ref2;
  const viewport = (0, _ViewportProvider.useViewport)();
  const themeTokens = (0, _ThemeProvider.useThemeTokens)('ProductCard', tokens, {
    viewport
  });
  const getCopy = (0, _utils.useCopy)({
    copy,
    dictionary
  });
  const {
    currentValue,
    setValue
  } = (0, _utils.useInputValue)();
  const hasClicked = isSelected || currentValue;
  const handlePress = event => {
    if (cardId) {
      onSelect(cardId);
    } else {
      setValue(!currentValue, event);
    }
  };
  const renderButton = hasClicked ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    vertical: 1,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_StackView.default, {
      space: 2,
      direction: "row",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: themeTokens.selectedButtonIcon,
        variant: {
          color: 'success'
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        variant: {
          size: 'h4'
        },
        tokens: {
          fontWeight: 400
        },
        children: getCopy('selectedButtonLabel')
      })]
    })
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
    onPress: handlePress,
    variant: {
      purpose: 'primary',
      size: 'small',
      width: 'full'
    },
    children: getCopy('buttonLabel')
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
    ...selectProps(rest),
    style: [selectProductCardTokens(themeTokens), staticStyles.container],
    ref: ref,
    children: [image?.src ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: staticStyles.imageContainer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, {
        source: image.src,
        style: staticStyles.image,
        alt: image.alt,
        accessibilityLabel: image.alt,
        resizeMethod: "resize",
        accessibilityIgnoresInvertColors: true
      })
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: staticStyles.textContainer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        left: 3,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_StackView.default, {
          space: 1,
          children: [getCopy('badgeText') ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Badge.default, {
            variant: {
              outline: true,
              purpose: 'editorial'
            },
            children: getCopy('badgeText')
          }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            variant: {
              size: 'h6'
            },
            children: getCopy('brandName')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            variant: {
              size: 'h4',
              colour: 'brand'
            },
            tokens: {
              fontWeight: 400
            },
            children: getCopy('productName')
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_StackView.default, {
            space: 3,
            divider: true,
            direction: "row",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PriceLockup.default, {
              ...getCopy('primaryPrice'),
              size: "small",
              ratePosition: "bottom"
            }), getCopy('secondaryPrice')?.price ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_PriceLockup.default, {
              ...getCopy('secondaryPrice'),
              size: "small",
              ratePosition: "bottom"
            }) : null]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
            top: 2,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_StackView.default, {
              space: 2,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
                variant: {
                  size: 'h6'
                },
                tokens: {
                  fontWeight: 500
                },
                children: getCopy('term')
              }), getCopy('buttonLabel') ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
                top: 1,
                children: renderButton
              }) : null]
            })
          })]
        })
      })
    })]
  });
});
ProductCard.displayName = 'ProductCard';

// If a language dictionary entry is provided, it must contain every key
const dictionaryContentShape = _propTypes.default.shape({
  badgeText: _propTypes.default.string,
  brandName: _propTypes.default.string.isRequired,
  productName: _propTypes.default.string.isRequired,
  primaryPrice: _propTypes.default.object.isRequired,
  secondaryPrice: _propTypes.default.object,
  term: _propTypes.default.string.isRequired,
  buttonLabel: _propTypes.default.string.isRequired,
  selectedButtonLabel: _propTypes.default.string.isRequired
});
ProductCard.propTypes = {
  ...selectedSystemPropTypes,
  image: _propTypes.default.shape({
    src: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
    alt: _propTypes.default.string
  }),
  /**
   * Select English or French copy for the place holder labels.
   * You may also pass in a custom dictionary object.
   */
  copy: _propTypes.default.oneOfType([_propTypes.default.oneOf(['en', 'fr'])]),
  /**
   * Override the default dictionary, by passing the complete dictionary object for `en` and `fr`
   */
  dictionary: _propTypes.default.shape({
    en: dictionaryContentShape,
    fr: dictionaryContentShape
  }),
  tokens: (0, _utils.getTokensPropType)('ProductCard')
};
var _default = exports.default = ProductCard;
const staticStyles = _StyleSheet.default.create({
  container: {
    flexDirection: 'row',
    flex: 1
  },
  imageContainer: {
    width: '30%',
    minWidth: 96,
    maxWidth: 96
  },
  image: {
    resizeMode: 'contain',
    width: '100%',
    height: undefined,
    // This is to maintain the aspect ratio
    aspectRatio: 0.8
  },
  textContainer: {
    width: '70%'
  }
});